<template lang="pug" src="./settings.pug"></template>
<style lang="scss" src="./settings.scss" scoped></style>

<script>
import { mapGetters } from 'vuex';

export default {
    data: () => ({
        settingRole: null
    }),
    computed: {
        ...mapGetters(['roleName', 'operator']),
    }
};
</script>
